import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Tooltip, Legend } from "recharts";

const DOMAIN_LABELS = {
  emotion_recognition: "Recon. emocional",
  microexpressions: "Microexpresiones",
  emotional_prosody: "Prosodia",
  empathy_affective: "Empatía afectiva",
  empathy_cognitive: "Empatía cognitiva",
  social_inferences: "Inferencias soc.",
  non_literal_language: "Leng. no literal",
  mentalization: "Mentalización",
  theory_of_mind: "T. de la Mente",
  interpersonal_regulation: "Reg. interpersonal",
  metacognition: "Metacognición",
};
const CANONICAL_ORDER = [
  "emotion_recognition","microexpressions","emotional_prosody",
  "empathy_affective","empathy_cognitive","social_inferences","non_literal_language",
  "mentalization","theory_of_mind","interpersonal_regulation","metacognition",
];

export default function CognitiveRadar({ pre, post, live, height = 340 }) {
  // Always show all 11 canonical domains in the same order (low→high)
  const preMap  = Object.fromEntries((pre?.scores  || []).map((s) => [s.domain, s.accuracy]));
  const postMap = Object.fromEntries((post?.scores || []).map((s) => [s.domain, s.accuracy]));
  const liveMap = Object.fromEntries((live?.scores || []).map((s) => [s.key, s.accuracy]));

  const data = CANONICAL_ORDER.map((d) => ({
    domain: DOMAIN_LABELS[d] || d,
    Actual: liveMap[d] != null ? Math.round(liveMap[d] * 100) : 0,
    PRE:    preMap[d]  != null ? Math.round(preMap[d]  * 100) : 0,
    POST:   postMap[d] != null ? Math.round(postMap[d] * 100) : 0,
  }));

  return (
    <div style={{ width: "100%", height }} data-testid="cognitive-radar">
      <ResponsiveContainer>
        <RadarChart data={data}>
          <PolarGrid stroke="hsl(var(--border))" />
          <PolarAngleAxis dataKey="domain" tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }} />
          <PolarRadiusAxis angle={30} domain={[0, 100]} tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }} />
          {live && (
            <Radar name="Actual" dataKey="Actual" stroke="hsl(var(--primary))" fill="hsl(var(--primary))" fillOpacity={0.45} />
          )}
          {pre && (
            <Radar name="PRE" dataKey="PRE" stroke="hsl(var(--chart-2))" fill="hsl(var(--chart-2))" fillOpacity={0.25} />
          )}
          {post && (
            <Radar name="POST" dataKey="POST" stroke="hsl(var(--accent))" fill="hsl(var(--accent))" fillOpacity={0.3} />
          )}
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Tooltip contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))" }} />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
